import styled from "styled-components";

export const BubbleTooltipArrowDefaultBox = styled.div`
    &, &:before {
      position: absolute;
      width: 12px;
      height: 12px;
      background: inherit;
    }

    visibility: hidden;
    
    &:before {
      visibility: visible;
      content: '';     
      transform: rotate(45deg);
      border-top: 1px solid ${({ theme }) => theme.colors.boxBorderContrast};
      border-left: 1px solid ${({ theme }) => theme.colors.boxBorderContrast};
    }
`;
